<div class="gallery-picker">
  <div class="gallery-toolbar">
    <button
      type="button"
      class="btn-back"
      (click)="goBack()"
      [disabled]="!currentPath"
    >
      رجوع
    </button>

    <div class="current-path">
      {{ currentPath || 'الرئيسية' }}
    </div>
  </div>

  <div class="loading" *ngIf="loading">
    جاري تحميل الجالري...
  </div>

  <ng-container *ngIf="!loading">
    <div class="folders-grid" *ngIf="folders.length > 0">
      <div
        class="folder-card"
        *ngFor="let folder of folders"
        (click)="openFolder(folder)"
      >
        <div class="folder-icon">📁</div>
        <div class="folder-name">{{ folder.name }}</div>
      </div>
    </div>

   <div class="images-grid" *ngIf="images.length > 0">
  <div
    class="image-card"
    *ngFor="let image of images"
    [class.selected]="isSelected(image)"
    (click)="toggleImage(image)"
  >
    <img
      [src]="image.url |ImageUrlPipe"
      [alt]="image.name"
      appImageFallback
    />

    <div class="image-check" *ngIf="isSelected(image)">
      ✓
    </div>

    <div class="image-name">
      {{ image.name }}
    </div>
  </div>
</div>

    <div class="empty-gallery" *ngIf="folders.length === 0 && images.length === 0">
      لا توجد صور أو فولدرات هنا
    </div>
  </ng-container>

  <div class="pagination" *ngIf="totalPages > 1">
    <button type="button" (click)="previousPage()" [disabled]="pageNumber <= 1">
      السابق
    </button>

    <span>صفحة {{ pageNumber }} من {{ totalPages }}</span>

    <button type="button" (click)="nextPage()" [disabled]="pageNumber >= totalPages">
      التالي
    </button>
  </div>
</div>